import { render, staticRenderFns } from "./save-category-sub.vue?vue&type=template&id=494ddf46"
import script from "./save-category-sub.vue?vue&type=script&lang=js"
export * from "./save-category-sub.vue?vue&type=script&lang=js"
import style0 from "./save-category-sub.vue?vue&type=style&index=0&id=494ddf46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports